export function downloadFile(url: string) {
  const anchor = document.createElement('a');
  anchor.setAttribute('href', url);
  anchor.click();
  anchor.remove();
}
